/* @ngInject */

export default (webpage) => {
  webpage.pageTitle('Organization switch in progress');
};
